import { render } from "./Clause.vue?vue&type=template&id=74e357c2&scoped=true"
import script from "./Clause.vue?vue&type=script&lang=js"
export * from "./Clause.vue?vue&type=script&lang=js"

import "./Clause.vue?vue&type=style&index=0&id=74e357c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e357c2"]])

export default __exports__